export var parseTimestamp = function(ts) {
    if (!ts) {
        return;
    }
    if ("toDate" in ts) {
        return ts.toDate();
    }
    return;
};
